<script>
	import DefaultView from './DefaultView.svelte';
	import OnboardingView from './OnboardingView.svelte';

	export let currentClient = 'tony_kealys';

	const getPlatform = () => {
		return 'shopify';
	};
</script>

<div class="app-container">
	<!-- {#if getPlatform() == 'shopify'} -->
	<!-- <OnboardingView {currentClient} /> -->
	<!-- {:else} -->
	<DefaultView {currentClient} />
	<!-- {/if} -->
</div>

<style>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
	}
</style>
